module.exports = __webpack_public_path__ + "static/home_06_mobile-be4d209588ecec3efca393561701db30.webp";